import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  changeUserPassword,
  fetchUserProfile,
  updateUserSettings,
} from "../../store/userSlice";

const UserSetting = () => {
  const dispatch = useDispatch();
  const { profile, status } = useSelector((state) => state.user);

  const [settings, setSettings] = useState({
    secondaryPhone: "",
    secondaryEmail: "",
    location: "",
    allJobAlert: true,
    resumeVisibility: true,
    disableAccount: false,
  });

  const [passwordForm, setPasswordForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  useEffect(() => {
    if (!profile) return;
    setSettings({
      secondaryPhone: profile.settings?.secondaryPhone || "",
      secondaryEmail: profile.settings?.secondaryEmail || "",
      location: profile.settings?.location || "",
      allJobAlert:
        profile.settings?.allJobAlert === undefined ? true : profile.settings.allJobAlert,
      resumeVisibility:
        profile.settings?.resumeVisibility === undefined
          ? true
          : profile.settings.resumeVisibility,
      disableAccount: Boolean(profile.settings?.disableAccount),
    });
  }, [profile]);

  const onSettingChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSettings((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onPasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordForm((prev) => ({ ...prev, [name]: value }));
  };

  const saveSettings = async (e) => {
    if (e?.preventDefault) e.preventDefault();
    try {
      await dispatch(updateUserSettings(settings)).unwrap();
      toast.success("Settings updated successfully");
    } catch (err) {
      toast.error(typeof err === "string" ? err : "Failed to update settings");
    }
  };

  const savePassword = async (e) => {
    if (e?.preventDefault) e.preventDefault();
    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      toast.error("New password and confirm password do not match");
      return;
    }

    try {
      await dispatch(
        changeUserPassword({
          currentPassword: passwordForm.currentPassword,
          newPassword: passwordForm.newPassword,
        })
      ).unwrap();
      toast.success("Password changed successfully");
      setPasswordForm({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
    } catch (err) {
      toast.error(typeof err === "string" ? err : "Failed to change password");
    }
  };

  return (
    <div className="form-wrapper">
      <div className="profile-form">
        <div className="section-title2">
          <h5>Profile Settings</h5>
        </div>

        <div className="change-password-area mb-40">
          <div className="info-title">
            <h6>Change Your Password</h6>
            <div className="dash" />
          </div>
          <form onSubmit={savePassword}>
            <div className="row">
              <div className="col-md-4">
                <div className="form-inner mb-25">
                  <label>Current Password</label>
                  <input
                    type="password"
                    name="currentPassword"
                    value={passwordForm.currentPassword}
                    onChange={onPasswordChange}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-inner mb-25">
                  <label>New Password</label>
                  <input
                    type="password"
                    name="newPassword"
                    value={passwordForm.newPassword}
                    onChange={onPasswordChange}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-inner mb-25">
                  <label>Confirm Password</label>
                  <input
                    type="password"
                    name="confirmPassword"
                    value={passwordForm.confirmPassword}
                    onChange={onPasswordChange}
                  />
                </div>
              </div>
              <div className="col-md-12">
                <button className="primry-btn-1 lg-btn w-unset" type="submit">
                  Update Password
                </button>
              </div>
            </div>
          </form>
        </div>

        <div className="phone-email-area">
          <div className="info-title">
            <h6>Phone & Email</h6>
            <div className="dash" />
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-inner mb-25">
                <label>Primary Number</label>
                <input type="text" value={profile?.phoneNumber || ""} disabled />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-inner mb-25">
                <label>Secondary Number</label>
                <input
                  type="text"
                  name="secondaryPhone"
                  value={settings.secondaryPhone}
                  onChange={onSettingChange}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-inner mb-25">
                <label>Primary Email</label>
                <input type="text" value={profile?.email || ""} disabled />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-inner mb-25">
                <label>Secondary Email</label>
                <input
                  type="email"
                  name="secondaryEmail"
                  value={settings.secondaryEmail}
                  onChange={onSettingChange}
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-inner mb-25">
                <label>Location</label>
                <input
                  type="text"
                  name="location"
                  value={settings.location}
                  onChange={onSettingChange}
                />
              </div>
            </div>
            <div className="col-md-4">
              <label>
                <input
                  type="checkbox"
                  name="allJobAlert"
                  checked={settings.allJobAlert}
                  onChange={onSettingChange}
                />{" "}
                All Job Alert
              </label>
            </div>
            <div className="col-md-4">
              <label>
                <input
                  type="checkbox"
                  name="resumeVisibility"
                  checked={settings.resumeVisibility}
                  onChange={onSettingChange}
                />{" "}
                Resume Visibility
              </label>
            </div>
            <div className="col-md-4">
              <label>
                <input
                  type="checkbox"
                  name="disableAccount"
                  checked={settings.disableAccount}
                  onChange={onSettingChange}
                />{" "}
                Disable Account
              </label>
            </div>
          </div>
        </div>

        <div className="col-md-12 pt-50">
          <div className="form-inner">
            <button className="primry-btn-2 lg-btn w-unset" type="button" onClick={saveSettings}>
              {status === "loading" ? "Updating..." : "Update Settings"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserSetting;
